module.exports = __webpack_public_path__ + "static/media/sf-test-2.9bdf87d1.mp3";